import React from 'react';

// Delete item dialog for confirmation
class DeleteItemDialog extends React.Component {

  constructor( props ) {
    super( props );

    this.default_layout = {
      'newbutton':{
        'caption':''
      }
    };

    this.state = {
      layout: this.props.layout === undefined ? this.default_layout : this.props.layout,
      show: this.props.show === undefined ? false : this.props.show,
      hasError: false,
      error: {},
      info: {}
    };
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      layout: nextProps.layout === undefined ? {} : nextProps.layout,
      show: nextProps.show === undefined ? false : nextProps.show,
    } );
  }

  render(){

    if( this.state.hasError === false ) {

      const layout = this.state.layout;
      const message = 'Are you sure you want to delete this ' + layout.newbutton.caption.toString() + '?';

      if( this.state.show === true ){
        return (
          <div className="delete-item-dialog" style={{top: '40%', left: '30%', right: '30%', bottom:'40%'}}>
            <div className="delete-item-dialog-header">
              <span>Delete Confirmation</span>
              <span className='delete-item-dialog-close-button' onClick={this.props.onCancel} >
                <i className="icon-fontello-cancel" />
              </span>
            </div>
            <div className="delete-item-dialog-body">
              <div style={{padding:'10px',height:'100%',width:'100%'}}>
                {message}
              </div>
            </div>
            <div className="delete-item-dialog-footer">
              <button className='delete-item-dialog-cancel-button' key='btnCancelDelete' onClick={this.props.onCancel}>Cancel</button>
              <button className='delete-item-dialog-confirm-button' key='btnConfirmDelete' onClick={this.props.onConfirm}>Confirm</button>
            </div>
          </div>
        );
      } else {
        return ( <span></span> );
      }
    } else {
      return ( <span></span> );
    }
  }
}

export default DeleteItemDialog;



// WEBPACK FOOTER //
// ./src/presentation/DeleteItemDialog.js